import { format } from 'date-fns'
import _ from 'lodash'

import { lengthInMonths } from '../utils/Dates.jsx'

const ritEmail = (
	leaseName,
	startDate,
	endDate,
	fairValue,
	expectedResidualValue,
	rateData,
	payments
) => {
	const leaseTerm = lengthInMonths(startDate, endDate)
	const formatStart = format(new Date(startDate), 'MMMM do, yyyy')
	const formatEnd = format(new Date(endDate), 'MMMM do, yyyy')
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	})

	function convertRate(inp) {
		let formattedInp = Number(inp) * 100
		return formattedInp.toFixed(2)
	}

	function buildTables(arr, index) {
		let grouped = _.groupBy(arr, (payment) => {
			return payment.year
		})
		let head = `<tr>
		<td valign="top">
		<h3 style="font-family: 'Open Sans', sans-serif; font-weight:700; color:#054086; font-size:25px;">Payment Schedule ${
			index + 1
		} for ${leaseName} lease:</h3>
		<table width="100%" border="1" bordercolor="#e7f0f9" align="center" cellpadding="10" cellspacing="0" style="border-collapse:collapse; border:solid 1px #e7f0f9;">
		`
		Object.keys(grouped).forEach((date) => {
			head += `
			<thead>
            <tr>
			    <td width="50%" style="font-size:18px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#fff; background-color:#054086; border-right:none;">${date}</td>
			    <td width="50%" style="font-size:18px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#fff; background-color:#054086; border-left:none;"></td>
            </tr>
            </thead>
            <tbody>
            `
			grouped[date].forEach((payment, index) => {
				let amount = payment ? payment.amountStr : '-'
				let date = payment ? payment.formattedDate : '-'
				if (index % 2 === 0) {
					head += `
                    <tr>
                        <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; border-right:none;">${date}</td>
                        <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; border-left:none;">${formatter.format(
													amount
												)}</td>
                    </tr>
                    `
				} else {
					head += `
                    <tr>
                        <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; background-color:#e7f0f9;">${date}</td>
                        <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; background-color:#e7f0f9;">${formatter.format(
													amount
												)}</td>
                    </tr>
                    `
				}
			})
		})
		head += `</tbody>
				</table>
           		</td>
            </tr> `
		return head
	}

	let paymentTable = ``
	payments.forEach((payment, index) => {
		paymentTable += buildTables(payment, index)
	})

	return `
    <!doctype html>
<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,700" rel="stylesheet">
<html>
<head>
    <meta charset="utf-8">
    <title>Rate Implicit in the Lease</title>

    <style>
        .main-img img { max-width: 100%; }
        @@media print {
            .no-print { display: none; }
            .b_blue { background-color: #2575bc; }
            .blue { background-color: #054086 } 
            body { background: transparent; }
            .blue_bg { background-color: #ecf6ff; }
        }
        .across { max-width: 100% }
    </style>
</head>

<body>
    <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
            <td style="padding:15px 0;">
                <table width="95%" border="0" align="center" cellpadding="0" cellspacing="0">
                    <tr>
                        <td style="font-family: 'Open Sans', sans-serif; font-weight:700; color:#054086; font-size:40px;">Rate Implicit in the Lease</td>
                        <td style="font-family: Roboto, 'Segoe UI', Tahoma, sans-serif; color:#828b90; font-size:15px; text-align:right;">Results Generated by <br><img src="https://leasequery.com/wp-content/uploads/2021/06/leasequery-logo.png" alt="" width="130" height="45" /></td>
                    </tr>
                </table>
            </td>
        </tr>

        <tr>
            <td valign="top">
                <table width="95%" border="0" align="center" cellpadding="0" cellspacing="0">
                    <tr>
                        <td valign="top">
                        <h1 style="font-family: 'Open Sans', sans-serif; font-weight:700; color:#828b90; font-size:25px;">Here are the details of the <b><span style="color: #054086">${leaseName}</span></b> lease:</h1>
                            <table width="100%" border="1" bordercolor="#e7f0f9" align="center" cellpadding="10" cellspacing="0" style="border-collapse:collapse; border:solid 1px #e7f0f9;">
                                <tr>
                                    <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; border-right:none;">Lease Commencement Date:</td>
                                    <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:400; padding-left:20px; border-left:none;">${formatStart}</td>
                                </tr>
                                <tr>
                                    <td width="50%" class="blue" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; background-color:#e7f0f9; padding-left:20px; color:#054086;">Lease End Date:</td>
                                    <td width="50%" class="blue" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:400; background-color:#e7f0f9; padding-left:20px;">${formatEnd}</td>
                                </tr>
                                <tr>
                                    <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; border-right:none;">Lease Term:</td>
                                    <td width="50%" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:400; padding-left:20px; border-left:none;">${leaseTerm}</td>
                                </tr>
                                <tr>
                                    <td width="50%" class="blue" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; background-color:#e7f0f9; padding-left:20px; color:#054086;">Fair Value of Asset at Lease Commencement:</td>
                                    <td width="50%" class="blue" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:400; background-color:#e7f0f9; padding-left:20px;">${formatter.format(
																			fairValue
																		)}</td>
                                </tr>
                                <tr>
                                    <td width="50%" class="blue" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:700; padding-left:20px; color:#054086; border-right:none;">Expected Residual Value of Asset at End of Lease Term:</td>
                                    <td width="50%" class="blue" style="font-size:14px; font-family: 'Open Sans', sans-serif; font-weight:400; padding-left:20px; border-left:none;">${formatter.format(
																			expectedResidualValue
																		)}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>                    
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                </table>
            </td>
        </tr>
        <tr>
            <td valign="top">
                <table width="95%" border="0" align="center" cellpadding="0" cellspacing="0">

                    <tr>
                        <td style="font-family: 'Open Sans', sans-serif; font-weight:700; font-size:30px; color:#054086;">Results</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td style="font-family: 'Open Sans', sans-serif; font-weight:400; font-size:25px; color:#363636;">Based on the inputs above, the rate implicit in your <b><span style="color: #054086">${leaseName}</span></b> lease is ${convertRate(
		rateData
	)}%.</td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                    <tr>
                        <td style="font-family: 'Open Sans', sans-serif; font-weight:700; font-size:30px; color:#054086;">Payments</td>
                    </tr>
					
					<tr>
						${paymentTable}
                    </tr>
                    
                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <table width="60%">
                    <tr>
                        <td width="50%" style="font-size:16px; font-family: 'Open Sans', sans-serif; font-weight:700; padding:10px; color:#fff; background-color:#79b3d3; text-align:center;"><a href='https://leasequery.com/free-demo/' style="color:#fff; text-decoration:none; ">REQUEST A FREE DEMO</a></td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td width="50%" style="font-size:16px; font-family: 'Open Sans', sans-serif; font-weight:700; padding:10px; color:#fff; background-color:#f57e25; text-align:center;"><a href='https://tools.leasequery.com/rate-implicit-calculator' style="color:#fff; text-decoration:none; ">USE THE CALCULATOR AGAIN</a></td>
                    </tr>
                    </table>

                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>

                    <tr>
                        <td height="40" align="center" style="border-top:solid 1px #e6e9e9; font-family: 'Open Sans', sans-serif; font-weight:400; font-size:17px; color:#6e6e6e; padding-top:10px;">Thank you for using our free Rate Implicit Calculator, Powered by <a href="https://leasequery.com/" style="color:#2575bc; text-decoration:none;">LeaseQuery.com</a></td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>    
</body>
</html>
  `
}

export default ritEmail
